import React, { lazy } from 'react'
import ComponentLoader from './component-loader'
import { useLocationInfo } from 'context/location'
import LumpLayout from 'screens/lump/lump-layout'

// LUMP ROUTES
// COUPON
const Coupon = ComponentLoader(lazy(() => import('screens/lump/coupon')))
const CampaignList = ComponentLoader(
  lazy(() => import('screens/lump/coupon/campaign-list'))
)
const CreateCampaign = ComponentLoader(
  lazy(() => import('screens/lump/coupon/create/create-campaign'))
)
const CampaignInsight = ComponentLoader(
  lazy(() => import('screens/lump/coupon/insight'))
)

// TICKET
const Ticket = ComponentLoader(lazy(() => import('screens/lump/ticket')))

// CARD
const Card = ComponentLoader(lazy(() => import('screens/lump/card')))

// SCANNER
const ScannerModule = ComponentLoader(
  lazy(() => import('screens/lump/Scanner'))
)
const Scanner = ComponentLoader(
  lazy(() => import('screens/lump/Scanner/scanners'))
)
const ScannerLogs = ComponentLoader(
  lazy(() => import('screens/lump/Scanner/logs'))
)
// const Scanner = ComponentLoader(lazy(() => import('screens/lump/Scanner')))

const Pass = ComponentLoader(lazy(() => import('screens/public/Pass')))

const LumpRoutes = () => {
  const { isAccessable } = useLocationInfo()
  console.log('CAMAPIGN', isAccessable('campaign'))
  return [
    {
      path: '/wallet/:company_id/:locationId',
      element: <LumpLayout />,
      children: [
        {
          path: 'coupon',
          element: <Coupon />,
          children: [
            {
              path: '',
              index: true,
              element: <CampaignList />,
            },
            {
              path: 'create',
              element: <CreateCampaign />,
            },
            {
              path: 'update',
              element: <CreateCampaign />,
            },
            {
              path: 'insight',
              element: <CampaignInsight />,
            },
          ],
        },
        {
          path: 'ticket',
          element: <Ticket />,
        },
        {
          path: 'card',
          element: <Card />,
        },
        {
          path: 'scanner',
          element: <ScannerModule />,
          children: [
            {
              path: '',
              element: <Scanner />,
              index: true,
            },
            // {
            //   path: 'staff',
            //   element: <Staff />,
            // },
            {
              path: 'logs',
              element: <ScannerLogs />,
            },
            // {
            //   path: 'usercode-table',
            //   element: <UsercodeTable />,
            // },
          ],
        },
        {
          path: 'pass/:pass_code',
          element: <Pass />,
        },
      ],
    },
  ]
}

export default LumpRoutes
